import { Capacitor } from '@capacitor/core';

export default function SafeAreaSpacer() {
  if (!Capacitor.isNativePlatform()) return null;

  return <div className="bg-background" style={{
    position: 'fixed',
    width: '100%',
    height: `var(--safe-area-inset-top)`,
    zIndex: 9999,
  }} />;
} 